import { useEffect } from "react";
import { takePendingComposerDraft } from "./pendingComposerDraft";

// Apply a brand-new conversation's queued composer draft (e.g. a quick action's
// seed prompt) to the composer exactly once, as an editable pre-fill — never a
// sent turn. Consumes from the durable queue inside a deferred microtask, past
// the `cancelled` check, so React Strict Mode's mount→unmount→mount doesn't take
// the draft on a mount that is about to be discarded (which would drop it). The
// destructive take, keyed by conversation id, is itself the exactly-once guard:
// a re-run finds the queue already drained and applies nothing.
export function usePendingComposerDraft(
  conversationId: string,
  onApply: (draft: string) => void
): void {
  useEffect(() => {
    let cancelled = false;
    queueMicrotask(() => {
      if (cancelled) return;
      const draft = takePendingComposerDraft(conversationId);
      if (!draft) return;
      onApply(draft);
    });
    return () => {
      cancelled = true;
    };
  }, [conversationId, onApply]);
}
